<template>
  <div class="plat-student-info-dashboard">
    <div class="header">
      <div class="nav">
        <el-button type="text"
                   icon="el-icon-arrow-left"
                   @click="hidePopover"></el-button>
      </div>
      <div class="tab">
        <el-radio-group v-model="current">
          <el-radio-button v-for="dataType in dataTypes"
                           :key="dataType.value"
                           :label="dataType.value">
            <span :class="{'theme-text': current === dataType.value}">{{dataType.label}}</span>
            <span v-if="current === dataType.value"
                  class="tab-bar theme-bg"></span>
          </el-radio-button>
        </el-radio-group>
      </div>
      <div class="end">
        <el-button :class="{'is-refresh': refresh[current]}"
                   type="text"
                   icon="el-icon-refresh"
                   :disabled="refresh[current]"
                   @click="handleRefresh"></el-button>
      </div>
    </div>
    <div class="main">
      <div class="main-cont">
        <div class="info-column">
          <PlatStudentOutlineInfo ref="outline"
                                  v-bind="$attrs"></PlatStudentOutlineInfo>
        </div>
        <div class="main-column">
          <keep-alive>
            <component ref="tab"
                       :is="tabComponent"
                       :tab="current"
                       v-bind="$attrs"
                       @start-refresh="startRefresh"
                       @end-refresh="endRefresh"
                       @info-update="onInfoUpdate"></component>
          </keep-alive>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PlatStudentOutlineInfo from './outline'
import PlatStudentBasicInfo from './basic'
import PlatStudentCourseInfo from './course'
import PlatStudentAccountInfo from './account'
export default {
  name: 'PlatStudentInfoDashboard',
  components: {
    PlatStudentOutlineInfo
  },
  data () {
    return {
      dataTypes: [{
        label: '基本信息',
        value: 'basic'
      }, {
        label: '课程详情',
        value: 'course'
      }, {
        label: '账号详情',
        value: 'account'
      }],
      current: '',
      refresh: {}
    }
  },
  computed: {
    tabComponent () {
      switch (this.current) {
        case 'basic':
          return PlatStudentBasicInfo
        case 'course':
          return PlatStudentCourseInfo
        case 'account':
          return PlatStudentAccountInfo
      }
    }
  },
  methods: {
    hidePopover () {
      this.$emit('hidePopover')
    },
    handleRefresh () {
      const tab = this.$refs.tab
      if (tab) {
        tab.handleRefresh()
      }
    },
    startRefresh (tab) {
      this.$set(this.refresh, tab, true)
    },
    endRefresh (tab) {
      this.$set(this.refresh, tab, false)
    },
    onInfoUpdate () {
      const outline = this.$refs.outline
      if (outline) {
        outline.loadOutlineInfo()
      }
      this.$emit('reloadGridData')
    }
  },
  watch: {
    current (newVal, oldVal) {
      // 使用watch监听current，当current为account时，刷新tab组件, 因为在BasicInfo中修改学号会更新账号, 账号变动时没法通知account刷新
      if (newVal === 'account') {
        // 延迟执行，确保组件已完全加载
        this.$nextTick(() => {
          const tab = this.$refs.tab
          if (tab && tab.handleRefresh) {
            tab.handleRefresh()
          }
        })
      }
    }
  },
  created () {
    this.current = this.dataTypes[0].value
  }
}
</script>

<style lang="scss">
  .plat-student-info-dashboard {
    height: 100%;
    display: flex;
    flex-direction: column;
    & > .header {
      position: relative;
      flex: none;
      display: flex;
      justify-content: center;
      background-color: #fff;
      border-bottom: 1px solid #ebeef5;
      padding: 0 50px;
      & > .nav {
        position: absolute;
        left: 8px;
        top: 50%;
        transform: translateY(-50%);
        .el-button {
          width: 30px;
          padding: 9px 0;
          i {
            font-size: 16px;
            font-weight: bold;
          }
        }
      }
      & > .tab {
        width: 640px;
        max-width: 100%;
        .el-radio-group {
          display: flex;
          justify-content: space-around;
          align-items: center;
          .el-radio-button {
            .el-radio-button__inner {
              position: relative;
              color: #303133;
              font-size: 13px;
              padding: 16px 20px;
              box-shadow: none!important;
              background-color: transparent!important;
              border: none!important;
              overflow: hidden;
              span {
                transition: all .3s;
              }
              .tab-bar {
                position: absolute;
                left: 50%;
                bottom: 0;
                width: 40px;
                height: 3px;
                margin-left: -20px;
                animation: tabBar .3s forwards;
              }
              @keyframes tabBar {
                from {
                  opacity: .5;
                  transform: translateY(100%);
                }
                to {
                  opacity: 1;
                  transform: translateY(0);
                }
              }
            }
          }
        }
      }
      & > .end {
        position: absolute;
        right: 15px;
        top: 50%;
        transform: translateY(-50%);
        .el-button {
          width: 30px;
          padding: 9px 0;
          i {
            font-size: 16px;
            font-weight: bold;
          }
          &.is-refresh {
            i {
              animation: refreshing 1s infinite linear;
              transform-origin: center center;
            }
          }
        }
        @keyframes refreshing {
          from {
            transform: rotate(0);
          }
          to {
            transform: rotate(360deg);
          }
        }
      }
    }
    & > .main {
      flex: auto;
      position: relative;
      & > .main-cont {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        & > .info-column {
          position: absolute;
          left: 0;
          top: 0;
          width: 220px;
          bottom: 0;
        }
        & > .main-column {
          position: absolute;
          left: 220px;
          top: 0;
          right: 0;
          bottom: 0;
        }
      }
    }
  }
</style>
